// This file is auto-generated by @hey-api/openapi-ts

/**
 * Ticket state.
 */
export const ThirdPartyTicketStatesEnum = {
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
} as const;

/**
 * Ticket state.
 */
export type ThirdPartyTicketStatesEnum = typeof ThirdPartyTicketStatesEnum[keyof typeof ThirdPartyTicketStatesEnum];
